var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoCoverVertical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 53.5,
    viewBox: "0 0 95 53.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M0 0h95v154H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.33 13.33)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.712 27.854h-4.291a.2.2 0 0 1-.2-.2V.181A.182.182 0 0 1 16.402 0h4.31a7.142 7.142 0 0 1 7.142 7.142v13.57a7.142 7.142 0 0 1-7.142 7.142Zm1.02-15.354a2.816 2.816 0 1 0 2.816 2.82 2.82 2.82 0 0 0-2.816-2.82Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.23 27.854H7.142A7.142 7.142 0 0 1 0 20.712V7.142A7.142 7.142 0 0 1 7.142 0h6.088a.2.2 0 0 1 .2.2v27.45a.2.2 0 0 1-.2.204ZM7.142 2.246a4.9 4.9 0 0 0-4.9 4.9v13.57a4.9 4.9 0 0 0 4.9 4.9h4.047V2.246Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 2.619,
    cy: 2.619,
    r: 2.619,
    transform: "matrix(.025 -1 1 .025 4.272 10.909)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCoverVertical);
export default __webpack_public_path__ + "static/media/no-cover-vertical.79aba4c370bc01052751b475455ec6d7.svg";
export { ForwardRef as ReactComponent };